import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import EditButton from './EditButton'

const Button = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 15px 15px 15px 0px;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 2px;
    letter-spacing: 2px;
    cursor: pointer;
    user-select: none;
    color: rgb(41, 150, 218);

    button {
        display: none;
    }

    :hover {
        button {
            display: inline-flex;
        }
    }
`

const Link = styled.span`
    :not(:last-child) {
        padding-right: 10px;
        border-right: 1px solid;
        margin-right: 10px;
    }
`

const EventControl = ({type, id, data, onEdit, intl}) => {
    const handleClick = () => {
        onEdit(type, id, data)
    }

    return (
        <Button>
            <div>
                <Link>{intl.formatMessage({id: "editor.event_google"})}</Link>
                <Link>{intl.formatMessage({id: "editor.event_ios"})}</Link>
                <Link>{intl.formatMessage({id: "editor.event_outlook"})}</Link>
				<Link>{intl.formatMessage({id: "editor.event_office"})}</Link>
            </div>
            <EditButton onClick={handleClick} />
        </Button>
    )
}

export default injectIntl(EventControl)
